
import { PropTypes } from 'prop-types';
import ModelButton from '../../modelBtn/modelButton';
import { useEffect, useState } from 'react';



const Grid = ({ card }) => {
    const [modalOpen, setModalOpen] = useState(false);

    

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         if (modalOpen) {

    //             document.getElementsByClassName("accordion")[0]?.classList.remove("z-[1]");
    //         } else {
    //             document.getElementsByClassName("accordion")[0]?.classList.add("z-[1]");
    //         }
    //     }
    // }, [modalOpen])
    return (
        card?.children ?
            <>
                <div
                    onClick={
                        () => (modalOpen ? closed() : open())
                    }
                    className='relative overflow-hidden rounded-3xl bg-gray-200 cursor-pointer'>
                    {
                        card?.img ? <img src={card.img} alt={card.text} className='w-full h-80 object-cover ' />
                            : <div className='w-full h-80' />
                    }

                    <div className="absolute inset-0 bg-black bg-opacity-35" />
                    <h1 className='text-3xl  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold text-white mt-2 text-center'>{card.text}</h1>
                </div>
                <ModelButton modalOpen={modalOpen} close={closed}>
                    
                        {card?.children}
                   
                </ModelButton>
            </>
            :
            <div
                className='relative overflow-hidden rounded-3xl bg-gray-200'>
                {
                    card?.img ? <img src={card.img} alt={card.text} className='w-full h-80 object-cover ' />
                        : <div className='w-full h-80' />
                }

                <div className="absolute inset-0 bg-black bg-opacity-35" />
                <h1 className='text-3xl  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold text-white mt-2 text-center'>{card.text}</h1>
            </div>
    )

}
Grid.propTypes = {
    card: PropTypes.any
}

const ShowGrid = ({ cards }) => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3'>
            {
                cards?.map((card, index) => {
                    return (
                        <Grid key={index} card={card} />
                    )

                }
                )
            }
        </div>
    )
}
ShowGrid.propTypes = {
    cards: PropTypes.array
}
export default ShowGrid